import * as React from 'react';
import { CoughSession } from 'webportalclient';
import { useCurrentStudyConfigurationContext } from '../../../Core/CurrentStudyConfigurationContext';
import { useSecurityContext } from '../../../Core/SecurityContext';
import { CoughSessionStatusEnum, Permission } from '../../../misc/api/apiTypes';
import { Authorization } from "../../../misc/components/Authorization";
import Condition from '../../../misc/components/Condition';
import { PermissionEnum } from '../../../misc/api/ApiPermissionEnum';

export interface UnassignDeviceAuthProps {
    record: CoughSession;
    children: any;
}

export const UnassignDeviceAuth = (props: UnassignDeviceAuthProps) => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    if (props.record) {
        return (
            <Authorization permissionId={PermissionEnum.UnassignDevice}
                studyId={study.id}
                currentPermissions={currentUserPermissions}
            >
                <Condition test={() => props.record.status === CoughSessionStatusEnum.AwaitingData}>
                    {props.children}
                </Condition>
            </Authorization>
        );
    } else {
        return null;
    }

}
